import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LinkContainer } from 'react-router-bootstrap'

import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'

// Redux -------
import { useDispatch, useSelector } from 'react-redux'
import { listOrders } from '../actions/orderActions'

// Components -------
import Loader from '../components/Loader'
import Message from '../components/Message'

const OrderListScreen = ({ history }) => {
	const dispatch = useDispatch()

	const orderList = useSelector(state => state.orderList)
	const { loading, error, orders } = orderList

	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	useEffect(() => {
		if (userInfo && userInfo.isAdmin) {
			dispatch(listOrders())
		} else {
			history.push('/login')
		}
	}, [dispatch, history, userInfo])

	return (
		<>
			<h1>Orders</h1>

			{loading ? (
				<Loader />
			) : error ? (
				<Message variant="danger">{error}</Message>
			) : (
				<Table striped bordered hover responsive className="table-sm">
					<thead>
						<tr>
							<th>ID</th>
							<th>User</th>
							<th>Date</th>
							<th>Total</th>
							<th>Paid</th>
							<th>Delivered</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{orders.map(order => (
							<tr key={order._id}>
								<td>{order._id}</td>
								<td>{order.user && order.user.name}</td>
								<td>{order.createdAt.substring(0, 10)}</td>
								<td>${order.totalPrice}</td>
								<td align="center">
									{order.isPaid ? (
										order.paidAt.substring(0, 10)
									) : (
										<i
											className="fas fa-times"
											style={{ color: 'red' }}
										></i>
									)}
								</td>
								<td align="center">
									{order.isDelivered ? (
										order.deliveredAt.substring(0, 10)
									) : (
										<i
											className="fas fa-times"
											style={{ color: 'red' }}
										></i>
									)}
								</td>
								<td>
									<LinkContainer to={`/order/${order._id}`}>
										<Button className="btn-sm" variant="light">
											Details
										</Button>
									</LinkContainer>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			)}
		</>
	)
}

OrderListScreen.propTypes = {
	history: PropTypes.object.isRequired
}

export default OrderListScreen
